<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'choose_picture' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content>
    @for (image of _albums; track image; let i = $index) {
      <div class="img-row">
        <img class="img-frame" [src]="getImage(image.src)" (click)="useImage(image.src)"/>
      </div>
    }
  </div>
</div>
